
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';


// FIXED IMPORT: Only one set of dots ".." to stay inside src/
import config from "../Common/Configurations/APIConfig";

const ChangePassword = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState({
        current: false,
        new: false,
        confirm: false
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        if (errors[name]) {
            setErrors({
                ...errors,
                [name]: ''
            });
        }
    };

    const togglePasswordVisibility = (field) => {
        setShowPassword({
            ...showPassword,
            [field]: !showPassword[field]
        });
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.currentPassword.trim()) {
            newErrors.currentPassword = 'Current password is required';
        }

        if (!formData.newPassword.trim()) {
            newErrors.newPassword = 'New password is required';
        } else if (formData.newPassword.length < 8) {
            newErrors.newPassword = 'Password must be at least 8 characters';
        } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(formData.newPassword)) {
            newErrors.newPassword = 'Password must contain uppercase, lowercase and number';
        }

        if (!formData.confirmPassword.trim()) {
            newErrors.confirmPassword = 'Please confirm your password';
        } else if (formData.newPassword !== formData.confirmPassword) {
            newErrors.confirmPassword = 'Passwords do not match';
        }

        if (formData.currentPassword === formData.newPassword) {
            newErrors.newPassword = 'New password must be different from current password';
        }

        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setIsLoading(true);

        try {
            const token = localStorage.getItem('userToken');
            
            if (!token) {
                navigate('/login'); 
                throw new Error("You are not logged in.");
            }

            const url = `${config.APIACTIVEURL}${config.CHANGEPASSWORD}`;

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    currentPassword: formData.currentPassword,
                    newPassword: formData.newPassword,
                    confirmPassword: formData.confirmPassword
                })
            });

            if (response.status === 401) {
                localStorage.clear();
                navigate('/login');
                throw new Error("Session expired. Please login again.");
            }

            // Handle response data safely
            const contentType = response.headers.get("content-type");
            let data = null;
            if (contentType && contentType.indexOf("application/json") !== -1) {
                data = await response.json();
            } else {
                const text = await response.text();
                if(!response.ok) throw new Error(text || "Server Error");
            }

            if (!response.ok) {
                throw new Error(data?.Message || data?.message || "Failed to change password");
            }
            
            alert('Password changed successfully! You will be logged out.');
            
            localStorage.clear();
window.location.href = "/";

            
        } catch (error) {
            console.error("Change Password Error:", error);
            setErrors({ 
                submit: error.message || 'Failed to change password. Please try again.' 
            });
        } finally {
            setIsLoading(false);
        }
    };

    const passwordStrength = (password) => {
        if (!password) return { score: 0, text: '', color: '' };
        
        let score = 0;
        if (password.length >= 8) score += 1;
        if (/[a-z]/.test(password)) score += 1;
        if (/[A-Z]/.test(password)) score += 1;
        if (/[0-9]/.test(password)) score += 1;
        if (/[^A-Za-z0-9]/.test(password)) score += 1;

        const strength = {
            0: { text: 'Very Weak', color: '#dc3545' },
            1: { text: 'Weak', color: '#dc3545' },
            2: { text: 'Fair', color: '#ffc107' },
            3: { text: 'Good', color: '#20c997' },
            4: { text: 'Strong', color: '#20c997' },
            5: { text: 'Very Strong', color: '#198754' }
        };

        return { score, ...strength[score] };
    };

    const passwordStrengthInfo = passwordStrength(formData.newPassword);

    return (
        <div className="container-fluid py-4" style={{ paddingTop: '100px' }}>
            <div className="row justify-content-center">
                <div className="col-lg-6 col-md-8">
                    
                    <div className="card shadow-sm border-0">
                        <div className="card-header bg-white border-0 py-3">
                            <h3 className="mb-0 fw-bold text-dark">Change Password</h3>
                            <p className="text-muted mb-0">Secure your account by updating your password regularly</p>
                        </div>

                        <div className="card-body">
                            {errors.submit && (
                                <div className="alert alert-danger" role="alert">
                                    <i className="ri-error-warning-line me-2"></i>
                                    {errors.submit}
                                </div>
                            )}

                            <form onSubmit={handleSubmit}>
                                {/* Current Password */}
                                <div className="mb-4">
                                    <label htmlFor="currentPassword" className="form-label fw-semibold">
                                        Current Password
                                    </label>
                                    <div className="input-group">
                                        <input
                                            type={showPassword.current ? "text" : "password"}
                                            id="currentPassword"
                                            name="currentPassword"
                                            value={formData.currentPassword}
                                            onChange={handleInputChange}
                                            className={`form-control ${errors.currentPassword ? 'is-invalid' : ''}`}
                                            placeholder="Enter current password"
                                            disabled={isLoading}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary"
                                            onClick={() => togglePasswordVisibility('current')}
                                            disabled={isLoading}
                                        >
                                            <i className={showPassword.current ? "ri-eye-off-line" : "ri-eye-line"}></i>
                                        </button>
                                        {errors.currentPassword && (
                                            <div className="invalid-feedback">
                                                {errors.currentPassword}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* New Password */}
                                <div className="mb-4">
                                    <label htmlFor="newPassword" className="form-label fw-semibold">
                                        New Password
                                    </label>
                                    <div className="input-group">
                                        <input
                                            type={showPassword.new ? "text" : "password"}
                                            id="newPassword"
                                            name="newPassword"
                                            value={formData.newPassword}
                                            onChange={handleInputChange}
                                            className={`form-control ${errors.newPassword ? 'is-invalid' : ''}`}
                                            placeholder="Enter new password"
                                            disabled={isLoading}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary"
                                            onClick={() => togglePasswordVisibility('new')}
                                            disabled={isLoading}
                                        >
                                            <i className={showPassword.new ? "ri-eye-off-line" : "ri-eye-line"}></i>
                                        </button>
                                        {errors.newPassword && (
                                            <div className="invalid-feedback">
                                                {errors.newPassword}
                                            </div>
                                        )}
                                    </div>
                                    
                                    {/* Password Strength Meter */}
                                    {formData.newPassword && (
                                        <div className="mt-2">
                                            <div className="d-flex justify-content-between mb-1">
                                                <small className="text-muted">Password Strength:</small>
                                                <small style={{ color: passwordStrengthInfo.color, fontWeight: 'bold' }}>
                                                    {passwordStrengthInfo.text}
                                                </small>
                                            </div>
                                            <div className="progress" style={{ height: '4px' }}>
                                                <div 
                                                    className="progress-bar" 
                                                    role="progressbar" 
                                                    style={{ 
                                                        width: `${(passwordStrengthInfo.score / 5) * 100}%`,
                                                        backgroundColor: passwordStrengthInfo.color
                                                    }}
                                                ></div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Confirm Password */}
                                <div className="mb-4">
                                    <label htmlFor="confirmPassword" className="form-label fw-semibold">
                                        Confirm New Password
                                    </label>
                                    <div className="input-group">
                                        <input
                                            type={showPassword.confirm ? "text" : "password"}
                                            id="confirmPassword"
                                            name="confirmPassword"
                                            value={formData.confirmPassword}
                                            onChange={handleInputChange}
                                            className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
                                            placeholder="Confirm new password"
                                            disabled={isLoading}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary"
                                            onClick={() => togglePasswordVisibility('confirm')}
                                            disabled={isLoading}
                                        >
                                            <i className={showPassword.confirm ? "ri-eye-off-line" : "ri-eye-line"}></i>
                                        </button>
                                        {errors.confirmPassword && (
                                            <div className="invalid-feedback">
                                                {errors.confirmPassword}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Submit Buttons */}
                                <div className="d-flex justify-content-between">
                                    <button 
                                        type="submit" 
                                        className="btn btn-primary px-4"
                                        disabled={isLoading}
                                    >
                                        {isLoading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                Changing...
                                            </>
                                        ) : (
                                            <>
                                                <i className="ri-lock-line me-1"></i> Change Password
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>

                        {/* Security Tips */}
                        <div className="card-footer bg-white border-0 py-3">
                            <div className="alert alert-light border" role="alert">
                                <div className="d-flex">
                                    <i className="ri-shield-check-line text-primary fs-5 me-2"></i>
                                    <div>
                                        <h6 className="alert-heading mb-1">Security Tips</h6>
                                        <p className="mb-0 small text-muted">
                                            • Use a unique password for your account<br/>
                                            • Never share your password with anyone<br/>
                                            • Update your password regularly for better security
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangePassword;